if (
  typeof String !== undefined
  && String.prototype
  && !String.prototype.pluralize
) {
  Object.defineProperty(String.prototype, 'pluralize', {
    value(num, suffix = 's'){
      return num !== 1 ? `${this}${suffix}` : this;
    }
  });
}